"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitTypeToString = void 0;
function unitTypeToString(unitType, { plural = false, article = 'none' } = {}) {
    switch (unitType) {
        default:
            return `${article === 'indefinite'
                ? `${unitType.startsWith('a')
                    ? 'an'
                    : 'a'} `
                : ''}${unitType.replace(/([A-Z])/g, ' $1').toLowerCase()}${plural && unitType.length ? (!unitType.endsWith('s') ? 's' : "'") : ''}`;
    }
}
exports.unitTypeToString = unitTypeToString;
//# sourceMappingURL=unitTypeToString.js.map